import { LatLngLiteral, Location } from './types'

const RADIUS = Math.PI / 180
const EARTH_RADIUS = 6371

export const calcDistance = (a: LatLngLiteral, b: LatLngLiteral): number => {
  return (
    EARTH_RADIUS *
    2 *
    Math.asin(
      Math.sqrt(
        0.5 -
          Math.cos((b.lat - a.lat) * RADIUS) / 2 +
          (Math.cos(a.lat * RADIUS) *
            Math.cos(b.lat * RADIUS) *
            (1 - Math.cos((b.lng - a.lng) * RADIUS))) /
            2,
      ),
    )
  )
}

export const getLocationsWithin = (
  center: LatLngLiteral,
  distance: number,
  locations: Location[],
): Location[] =>
  locations.filter((location) => calcDistance(location, center) <= distance)

export const getLocationsFromLatLng = (
  locations: Location[],
  latLng: LatLngLiteral | google.maps.LatLng,
) => {
  if (!latLng) return []

  const lat = typeof latLng.lat === 'function' ? latLng.lat() : latLng.lat
  const lng = typeof latLng.lng === 'function' ? latLng.lng() : latLng.lng

  const indexedLocations = locations
    .filter((l) => l.lat === lat && l.lng === lng)
    .reduce(
      (acc, loc) => ({ ...acc, [loc.id]: loc }),
      {} as { [id: string]: Location },
    )

  return Object.values<Location>(indexedLocations)
}
